import { DataBean } from "../DataBean";

export class TimeEventPending extends DataBean {



    public async getTimeEventPendingForAccounting(year:any,month:any,page:any,recordsperpage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getTimeEventPendingForAccounting_Number_Number_Number_Number", [year,month,page,recordsperpage]);
    }
    
}